import React from "react";
import { BaseURL } from "../../constants/enum/baseURL.emum";

const Downloads = () => {
  return (
    <>
      <div className="container">
        <h3 className="text-start mt-3">ดาวน์โหลดเอกสาร</h3>
        <hr />
        <div className="row">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col" colSpan={2}>
                  แบบฟอร์มต่าง ๆ
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-start">{`[A05-01] แบบฟอร์ม-มคอ.3`}</td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/มคอ.3v.2-2.doc`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>

              <tr>
                <td className="text-start">{`[A05-01] แบบฟอร์ม-มคอ.4`}</td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/มคอ.4v.2.doc`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>

              <tr>
                <td className="text-start">{`[A09-03] แบบฟอร์ม-มคอ.5`}</td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/มคอ.5v.2.doc`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>

              <tr>
                <td className="text-start">{`[A09-03] แบบฟอร์ม-มคอ.6`}</td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/มคอ.6v.2.doc`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>

              <tr>
                <td className="text-start">{`แบบสรุป มคอ.3-4`}</td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/สรุป-มคอ.3-4.doc`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>

              <tr>
                <td className="text-start">{`แบบสรุป มคอ.5-6`}</td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/สรุป-มคอ.5-6.xls`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>

              <tr>
                <td className="text-start">{`แบบฟอร์ม อชว. (ระดับ ปวช.)`}</td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/แบบฟอร์ม อชว.(ระดับ-ปวช.).rar`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>

              <tr>
                <td className="text-start">{`แบบฟอร์ม อชว. (ระดับ ปวส.)`}</td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/แบบฟอร์ม อชว.(ระดับ-ปวส.).rar`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>
              <tr>
                <td className="text-start">
                  {`แบบฟอร์ม อชว. (ระดับ ปวช.) Update อชว.3 (เริ่มใช้ ปีการศึกษา 2/2566)`}
                </td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/แบบฟอร์ม-อชว.(ระดับ-ปวช.)-ปรับปรุง-อวช.3.rar`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>
              <tr>
                <td className="text-start">
                  {`แบบฟอร์ม อชว. (ระดับ ปวส.) Update อชว.3 (เริ่มใช้ ปีการศึกษา 2/2566)`}
                </td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/แบบฟอร์ม-อชว.(ระดับ-ปวส.)-ปรับปรุง-อวช.3.rar`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>
              <tr>
                <td className="text-start">
                  {`แบบฟอร์ม AUN.3 (สำหรับหลักสูตรที่ใช้เกณฑ์มาตรฐานหลักสูตร พ.ศ. 2565)`}
                </td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/แบบฟอร์ม-AUN-3_07-06-66.doc`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>
              <tr>
                <td className="text-start">
                  {`แบบฟอร์ม AUN.4 (สำหรับหลักสูตรที่ใช้เกณฑ์มาตรฐานหลักสูตร พ.ศ. 2565)`}
                </td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/แบบฟอร์ม-AUN-4_06-06-66.doc`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>

              <tr>
                <td className="text-start">
                  {`แบบ  R-1 (เกณฑ์มาตรฐานหลักสูตร 2565, เกณฑ์อาชีวศึกษา 2567)`}
                </td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/1แบบR-1(ปริญญาเกณฑ์65+อาชีว67).doc`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>

              <tr>
                <td className="text-start">
                  {`แบบ ปรับปรุง R-1.1 (เกณฑ์มาตรฐานหลักสูตร 2565, เกณฑ์อาชีวศึกษา 2567)`}
                </td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/2แบบปรับปรุงR-1.1(ปริญญาเกณฑ์65+อาชีว67).doc`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>

              <tr>
                <td className="text-start">
                  {`แบบ  R-2 (เกณฑ์มาตรฐานหลักสูตร 2565, เกณฑ์อาชีวศึกษา 2567)`}
                </td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/3แบบR-2(ปริญญาเกณฑ์65+อาชีว67).doc`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>

              <tr>
                <td className="text-start">
                  {`แบบสรุปผลการจัดทำรายละเอียดของรายวิชา-R1`}
                </td>
                <td className="text-end">
                  <a
                    className="btn btn-info btn-sm"
                    href={`${BaseURL.BASE_URL}/upload/downloads/แบบสรุปผลการจัดทำรายละเอียดของรายวิชา-R1.doc`}
                  >
                    ดาวน์โหลด
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Downloads;
